let statusListenerForBodyClose = false;

function uploaderSetup(makeRequest, scriptKey, modelID, dataForSending) {
  const loaderWrapper = document.querySelector('[data-js="loader-wrapper"]');

  function blockUnload(e) {
    e.preventDefault();
    e.returnValue = '';
  }

  window.driveUploaderCallback = function(status, result, instance) {
    if (status == 'init') {
      const date = new Date().toISOString().slice(0, 10);
      dataForSending.folderName = `${date}`;
      instance.setCustomSubfolderName(dataForSending.folderName);
    }

    if (status == 'start') {
      window.addEventListener('beforeunload', blockUnload);
      loaderWrapper.setAttribute('data-blocked', 'true');
    }

    if (status == 'done') {
      window.removeEventListener('beforeunload', blockUnload);
      loaderWrapper.setAttribute('data-blocked', 'false');

      const button = document.querySelector('.uploader__done-footer-embed a.uploader__button')
      button.addEventListener('click', e => {
        e.preventDefault();
        reloadUploaderScript();

        loaderWrapper.classList.remove('loader-wrapper_active');
        document.querySelector('body').removeEventListener('click', listenerForBodyClose);
        statusListenerForBodyClose = false;
      })

      if (!dataForSending.tagId) {
        dataForSending.tagId = document.querySelector('.category__list-item_active').dataset.tagId;
      }
     
      makeRequest('./add-content.php', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model_id: modelID,
          folder_name: dataForSending.folderName,
          tag_id: dataForSending.tagId,
          files: result.files
        })
      });
    }
  };

  reloadUploaderScript();

  function reloadUploaderScript() {
    const script = document.querySelector('script[src^="https://driveuploader.com/upload/"][src$="/embed.js"]');

    if (script) {
      script.remove();
      document.querySelector('[data-js="loader-wrapper"]').innerHTML = '<div class="driveuploader-replace"></div>';
    }

    const newscript = document.createElement('script');
    newscript.src = `https://driveuploader.com/upload/${scriptKey}/embed.js`;

    document.body.appendChild(newscript);
  }
}


function showUploader() {
  const uploaderWrapper = document.querySelector('[data-js="loader-wrapper"]');
  uploaderWrapper.classList.add('loader-wrapper_active');

  setTimeout(() => {
    document.querySelector('body').addEventListener('click', listenerForBodyClose)
    statusListenerForBodyClose = true;
  },200)
}

function listenerForBodyClose(e) {
  const uploaderWrapper = document.querySelector('[data-js="loader-wrapper"]');

  if (uploaderWrapper.dataset.blocked == "true") return

  if (!uploaderWrapper.querySelector('.uploader').contains(e.target)) {
    uploaderWrapper.classList.remove('loader-wrapper_active');

    document.querySelector('body').removeEventListener('click', listenerForBodyClose);
    statusListenerForBodyClose = false;
  }
}

function mainUploadButtonInit() {
  const button = document.querySelector('[data-js="main-upload-button"]')

  button.classList.add('tag-list__item-upload_active');
  button.addEventListener('click', () => showUploader());
}

export {uploaderSetup, mainUploadButtonInit};